import type { AddressSearchValue } from '~/lib/geo-providers/interfaces'
import { useFiltersStore } from '~/stores/useFiltersStore'
import { useSearchApplication } from '~/composables/useSearchApplication'

export const useLocationFilterSearch = () => {
  const filtersStore = useFiltersStore()
  const { searchStore, fetchResults } = useSearchApplication()

  const applyAddressSelection = (selection: AddressSearchValue): void => {
    searchStore.applyAddressSelection(selection)
  }

  const applyAddressText = (text: string): void => {
    searchStore.applyAddressText(text)
  }

  const clearLocation = (): boolean => {
    const hasLocationQuery = searchStore.getAddressString().length > 0

    searchStore.searchQuery = null
    searchStore.coordinates = null
    searchStore.bbox = null
    searchStore.place_type = null

    return hasLocationQuery
  }

  const refreshResults = async (): Promise<void> => {
    await fetchResults(filtersStore.getActiveFilters())
  }

  return { applyAddressSelection, applyAddressText, clearLocation, refreshResults }
}
